export default "__VITE_ASSET__a6a753d9__"